import "./organization-settings.scss";

import React, { useState } from "react";

import { GSListPage, GSInput, GSItemList, GSEmptyList } from "golfstatus_react_components";
import { faTimesCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { selectLoading } from "../../reducers/organizationSlice";
import { Outlet, useNavigate } from "react-router-dom";
import { useMatch } from "react-router-dom";
import NavigationListItem from "../navigation-list-item";
import { getSettingsPages } from "../../forms/SettingsForm";



const OrganizationSettings = () => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const match = useMatch("/:id/settings/*");
  const loading = useSelector(selectLoading)

  const clearText = () => {
    setSearch("");
  };

  const searchChanged = (e) => {
    setSearch(e.target.value);
  };
  const isSidePanelOpen = () => {
    return match?.params?.["*"] !== ""
  };
  const getRouter = () => {
    return <Outlet />;
  };
  const getListPage = (title) => {
    const page = {
      title: title,
      getDefaultSearch: getDefaultSearch,
      getItemList: getItemList,
      isSidePanelOpen: isSidePanelOpen,
      getRouter: getRouter,
    };
    return <GSListPage {...page} />;
  };
  const navigationSelected  = (page) => {
    if(isSidePanelOpen())
    {
      navigate(-1)
      return
    }
    navigate(page.url);
  }
  const searchResults = () => {
    let s = search?.toLowerCase?.()
    return getSettingsPages().filter?.(p => p.label?.toLowerCase?.().includes?.(s) || p.details?.toLowerCase?.().includes?.(s))
  }
  const getEmptySearchMessage = () => {
    return (
      <GSEmptyList
        title="We couldn’t find the setting you’re looking for…"
        detail="Try changing the search term."
        actions={[
          {
            title: "Clear Search",
            onClick: clearText,
            type: "light-grey",
          },
        ]}
      />
    );
  };
  const getItemList = () => {
    return (
      <GSItemList
        items={searchResults()}
        listItem={(page) => <NavigationListItem page={page} />}
        type="vertical selectable"
        emptyMessage={search ? getEmptySearchMessage() : "  "}
        itemSelected={navigationSelected}
        loading={loading?.includes?.("selectOrganization")}
        loadingMainText="Loading"
      ></GSItemList>
    );
  };
  const getDefaultSearch = () => {
    return (
      <div className="search">
        <GSInput
          textValue={search}
          rightIconClick={clearText}
          rightIcon={faTimesCircle}
          leftIcon={faSearch}
          onChange={searchChanged}
          placeholder="Search Settings & Preferences…"
        ></GSInput>
      </div>
    );
  };
  return (
    <organization-settings>{getListPage("Settings & Preferences")}</organization-settings>
  );
};

export default OrganizationSettings;
